// Angular
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns only first letter of string
 */
@Pipe({
	name: 'firstLetter'
})
export class FirstLetterPipe implements PipeTransform {

	/**
	 * Transform
	 *
	 * @param value: any
	 * @param args: any
	 */
	transform(value: any, args?: any): any {
		value = value.toUpperCase();
		
		//Gelen degerin icinde '.\Hasan' sekliden basinda ozel karakterler varsa bunlar cikarilir.
		var num = value.indexOf('.\\');
	
		if (num >= 0){
			value = value.substr(num+2, value.length);
		}
		return value.split(' ').map(n => n[0]).join('');
	}
}
